import { render, staticRenderFns } from "./ValidatedAndNoOneStemdoersAvailable.vue?vue&type=template&id=536a615c"
import script from "./validatedAndNoOneStemdoersAvailable.ts?vue&type=script&lang=ts&external"
export * from "./validatedAndNoOneStemdoersAvailable.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports